// extracted by mini-css-extract-plugin
module.exports = {"sparqlEditor":"SparqlEditor--sparqlEditor"};